// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"38fb360e","630":"d1a11f6f","666":"1bb53ffa","885":"5501e02f"}[chunkId] + ".chunk.css";
};